import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { arrayOf, bool, oneOfType, shape, string } from "prop-types";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { useLocation, useParams } from "react-router-dom";
import { actions as settingsActions } from "reducers/settings";
import * as Yup from "yup";

import Credential from "pages/_components/fields/credentials/Credential";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";
// import TransactionStatus from "pages/transactions/_components/TransactionStatus";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionSign } from "pages/_components/TransactionCard";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import CustomText from "pages/_components/CustomText/CustomText";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import Button from "pages/_components/Button";
import { transactionStatus } from "pages/transactions/constants";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { ResponsiveHeader } from "pages/_components/header";
import { isEmpty } from "lodash";
import { actions as loansActions } from "reducers/loans";
import { Field, Form, Formik } from "formik";
import { isIOS } from "react-device-detect";
import { sumAllTypeValues, sumAllValues } from "../../../util/number";

const CancelacionAnticipadaTicket = ({ fetching, transaction, isDesktop, accounts }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const dispatch = useDispatch();
    const params = useParams();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const [maskedAccount, setMaskedAccount] = useState("");
    const [detallePrestamo, setDetallePrestamo] = useState(null);
    const [readTx, setReadTx] = useState(false);
    const [showToken, setShowToken] = useState(false);
    const { user } = useSelector((_state) => _state.session);
    const { fetchingCancelation } = useSelector((_state) => _state.loans);
    const [buttonLabel, setButtonLabel] = useState(
        isDesktop ? "eunsecured.loan.seeMore.ticket.button" : "unsecured.loan.seeLess.ticket.button",
    );

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
              transaction.idTransactionStatus === transactionStatus.CANCELLED
            ? "tag-error"
            : "tag-warning";

    useEffect(() => {
        if (isEmpty(state?.transaction)) {
            dispatch(settingsActions.getUserData());
            dispatch(accountsActions.listAccounts());
        }
    }, []);

    useEffect(() => {
        if (params && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (readTx) {
                dispatch(formActions.readTransactionTicket(id));
            }
        }, 5000);
        return () => clearTimeout(timeout);
    }, [readTx]);

    useEffect(() => {
        if (transaction && transaction.data && transaction.data.loan && transaction.data.loan.approvalDate) {
            setDetallePrestamo(transaction.data.loan);
            setReadTx(false);
        } else {
            setReadTx(true);
        }
    }, [transaction]);

    const isBackoffice = pathname.includes("backoffice");
    const isLoading = fetching || !transaction?.data || !detallePrestamo;

    const handleSignTransaction = (values) => {
        if (values) {
            dispatch(
                loansActions.setCancelacionAnticipadaPayOff(
                    transaction.data.product.idProduct,
                    transaction.data.product.extraInfo,
                    values.credential,
                    transaction.data.debitAccount,
                    transaction.data.loan,
                    transaction.idTransaction,
                ),
            );
        }
    };

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "deposits.anticipatedCancelation",
        id,
        "accounts",
    );
    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    useEffect(() => {
        if (transaction.data) {
            setMaskedAccount(accounts.filter((acc) => acc.productId === transaction.data.debitAccount)[0]?.shortLabel);
        }
    }, [accounts]);

    // eslint-disable-next-line no-confusing-arrow
    const sign = () =>
        !showToken ? (
            <Col xs={12} md={4}>
                <CustomButton
                    func={() => setShowToken(true)}
                    text="forms.signTransaction.link"
                    textType="I18N"
                    className="btn btn-primary"
                />
            </Col>
        ) : (
            <Formik
                initialValues={{
                    credential: "",
                }}
                validationSchema={Yup.object().shape({
                    credential: Yup.string(),
                })}
                onSubmit={handleSignTransaction}>
                {() => (
                    <Form>
                        <Row>
                            <Col xs={12} md={4} mdOffset={2}>
                                <Field
                                    component={Credential}
                                    idForm="form.credential"
                                    name="credential"
                                    type="otp"
                                    labelText="form.credential.token.label"
                                    placeholderText="Ej: 120573"
                                />
                            </Col>
                            <Col xs={12} md={4} className="align-items-end">
                                <div className="form-group hidden-label">
                                    <div className="button-group">
                                        <Button
                                            block
                                            type="submit"
                                            label="global.send"
                                            bsStyle="primary"
                                            loading={fetchingCancelation}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        );

    const headerTicket = () => {
        if (detallePrestamo === undefined || detallePrestamo === null || !detallePrestamo) {
            return null;
        }
        return (
            <>
                <div className="ticket__wrapper col-12">
                    <div className="d-flex col-12 justify-content-center align-items-center">
                        <div className="d-flex flex-column mr-10">
                            <I18n id="menu.loans.detail.sucursal" defaultValue="Nº de préstamo" />
                            <b className="d-flex justify-content-center">
                                <CustomText text={detallePrestamo?.number} />
                            </b>
                        </div>
                        <div>
                            <div
                                style={{ borderRadius: "10px", padding: "15px" }}
                                className={`d-flex flex-column  ${tagType}`}>
                                <I18n id="menu.loans.detail.iva" defaultValue="Monto a cancelar" />
                                <b className="d-flex justify-content-center">
                                    <CustomText
                                        text={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.totalToCancel +
                                                        detallePrestamo?.chargesToCancel -
                                                        detallePrestamo?.bonification ?? 0
                                                }
                                            />
                                        }
                                    />
                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("unsecured.loan.seeLess.ticket.button");
        } else {
            setButtonLabel("unsecured.loan.seeMore.ticket.button");
        }
    };

    const showMoreTicket = () => {
        if (detallePrestamo === undefined || detallePrestamo === null || !detallePrestamo) {
            return null;
        }
        return (
            <>
                <div className="ticket__body ">
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button no-print"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            defaultLabelText="Ver más detalle"
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                </div>
                <div className={`${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket__body ticket__full-width">
                        <h2 className="pb-6">{i18n.get("", "Datos adicionales")}</h2>
                        <GridTable>
                            <GridTable.Container className="gap-6">
                                <GridTable.Data rowStart={1} columnStart={1}>
                                    <CustomData
                                        titleTextType="TEXT"
                                        titleText="Moneda"
                                        valueText={detallePrestamo?.currency}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={1} columnStart={2}>
                                    <CustomData
                                        titleText="loans.anticipatedCancelation.effectiveMonthlyRate"
                                        titleTextType="I18N"
                                        valueText={
                                            detallePrestamo?.rates?.find((x) => x.code === "rate_value_tem")?.value ?? 0
                                        }
                                        valueTextType="PERCENTAGE"
                                    />
                                </GridTable.Data>

                                <GridTable.Data rowStart={2} columnStart={1}>
                                    <CustomData
                                        titleText="Capital original"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={detallePrestamo?.totalAmount ?? 0}
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={2} columnStart={2}>
                                    <CustomData
                                        titleText="Capital adeudado"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={detallePrestamo?.pendingBalance ?? 0}
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={3} columnStart={1}>
                                    <CustomData
                                        titleText="Comisión cancelación anticipada"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.charges?.find((x) => x.code === "COMISION")
                                                        ?.value ?? 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={3} columnStart={2}>
                                    <CustomData
                                        titleText="Percepción de IVA"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.charges
                                                        ? sumAllTypeValues(
                                                              detallePrestamo?.charges,
                                                              "code",
                                                              "PERCEP_IVA",
                                                          )
                                                        : 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={4} columnStart={1}>
                                    <CustomData
                                        titleText="Intereses"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.payments
                                                        ? sumAllValues(detallePrestamo?.payments, "interestPaid")
                                                        : 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={4} columnStart={2}>
                                    <CustomData
                                        titleText="IVA"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.charges
                                                        ? sumAllTypeValues(detallePrestamo?.charges, "code", "IVA")
                                                        : 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={5} columnStart={1}>
                                    <CustomData
                                        titleText="IIBB"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.charges
                                                        ? sumAllTypeValues(detallePrestamo?.charges, "code", "IIBB")
                                                        : 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={5} columnStart={2}>
                                    <CustomData
                                        titleText="Impuesto de sellos"
                                        valueText={
                                            <FormattedAmount
                                                currency="ARS"
                                                quantity={
                                                    detallePrestamo?.charges
                                                        ? sumAllTypeValues(detallePrestamo?.charges, "code", "SELLADOS")
                                                        : 0
                                                }
                                            />
                                        }
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={6} columnStart={1}>
                                    <CustomData
                                        titleText="Cuenta de acreditación y débito"
                                        valueText={!!maskedAccount && <CustomText text={`····${maskedAccount}`} />}
                                    />
                                </GridTable.Data>
                                <GridTable.Data rowStart={7} columnStart={1}>
                                    <div
                                        aria-hidden="true"
                                        className={isIOS ? "whitespace-nowrap btn-link" : "btn-link"}
                                        onClick={() => {
                                            dispatch(loansActions.downloadUnsecuredLoansApplicationTerms());
                                        }}>
                                        {i18n.get("global.termAndConditions")}
                                    </div>
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                    </div>
                    <div className="ticket__body ticket__full-width">
                        <TransactionSign
                            creationTime
                            isDesktop={isDesktop}
                            hasVaucher
                            isSmall
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
                <Row className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
            </>
        );
    };
    return (
        <Fragment>
            <Notification scopeToShow="accounts" />
            {!isBackoffice && <ResponsiveHeader ticket id="deposits.anticipatedCancelation" />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            {transaction.idTransactionStatus === transactionStatus.FINISHED ? (
                                <div className="media-object  column">
                                    <div className="text-center">
                                        {isDesktop && <h1>{i18n.get("", "Cancelación anticipada")}</h1>}
                                        <h3>{i18n.get("", "Cancelación exitosa")}</h3>
                                    </div>
                                    <div className="illustration text-center">
                                        <Image
                                            src="images/figma/illustrations/ticket-success.svg"
                                            className="svg-image logo"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="media-object  column">
                                    <div className="text-center">
                                        {isDesktop && <h1>{i18n.get("", "Cancelación anticipada")}</h1>}
                                        <h3>{i18n.get("", "Cancelación pendiente de firmas")}</h3>
                                    </div>
                                    <div className="illustration text-center">
                                        <Image
                                            src="images/figma/illustrations/ticket-pending.svg"
                                            className="svg-image logo"
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body ticket__full-width">
                                        <GridTable>
                                            <GridTable.Container>{headerTicket()}</GridTable.Container>
                                        </GridTable>
                                    </div>

                                    <>{showMoreTicket()}</>
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <>
                                {!showToken && (
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <CustomButton
                                            func={() => dispatch(routerActions.push("/desktop"))}
                                            text="forms.transaction.ticket.actions.backToHome"
                                            textType="I18N"
                                            className="btn btn-outline"
                                        />
                                    </Col>
                                )}
                                {transaction.idTransactionStatus === transactionStatus.FINISHED ? (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/download.svg"
                                            label="global.download"
                                            onClick={handleDownload}
                                        />
                                    </Col>
                                ) : (
                                    <>{showSignButton && sign()}</>
                                )}
                                {transaction.idTransactionStatus === transactionStatus.FINISHED && !isDesktop && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            className="btn btn-outline"
                                            image="images/figma/icon/share.svg"
                                            label="global.share"
                                            onClick={() => {
                                                handleShareMobile();
                                            }}
                                        />
                                    </Col>
                                )}
                            </>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </Fragment>
    );
};

CancelacionAnticipadaTicket.propTypes = {
    isDesktop: bool.isRequired,
    // newAccountTicketSignable: bool.isRequired,
    transaction: shape({}).isRequired,
    // fetchingAccounts: bool.isRequired,
    fetching: oneOfType([string, bool]),
    accounts: arrayOf(shape({})).isRequired,
};

CancelacionAnticipadaTicket.defaultProps = {
    fetching: false,
};

const mapStateToProps = (state) => ({
    accounts: accountsSelectors.getAccounts(state),
    fetchingAccounts: accountsSelectors.getFetching(state),
    transaction: formSelectors.getTransaction(state),
});

export default connect(mapStateToProps)(CancelacionAnticipadaTicket);
